import LegalLayout, {
  LegalSection,
  LegalParagraph,
  LegalAddress,
  type UnsfNavbarProps,
  type UnsfFooterProps,
} from "@/components/unsf/LegalLayout"
import type { UnsfMeta } from "@/components/unsf/UnsfHead"

interface Step {
  number: string
  text: string
  link?: { label: string; href: string }
  text_after?: string
}

interface Props {
  meta: UnsfMeta
  title: string
  subtitle: string
  period_section: { title: string; text: string }
  conditions_section: { title: string; items: string[] }
  shipping_section: { title: string; text: string }
  how_section: { title: string; steps: Step[] }
  address_section: { title: string; lines: string[] }
  refunds_section: { title: string; text: string }
  exchanges_section: { title: string; text: string }
  navbar: UnsfNavbarProps
  footer: UnsfFooterProps
  csrf_token: string
  cart: import("@/components/unsf/Cart").CartData
}

export default function Returns({
  meta,
  title,
  subtitle,
  period_section,
  conditions_section,
  shipping_section,
  how_section,
  address_section,
  refunds_section,
  exchanges_section,
  navbar,
  footer,
  csrf_token,
  cart,
}: Props) {
  return (
    <LegalLayout
      meta={meta}
      title={title}
      intro={subtitle}
      navbar={navbar}
      footer={footer}
      csrfToken={csrf_token}
      cart={cart}
    >
      <LegalSection title={period_section.title}>
        <LegalParagraph>{period_section.text}</LegalParagraph>
      </LegalSection>

      <LegalSection title={conditions_section.title}>
        <ul className="text-content space-y-3 list-disc pl-6">
          {conditions_section.items.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection title={shipping_section.title}>
        <LegalParagraph>{shipping_section.text}</LegalParagraph>
      </LegalSection>

      <LegalSection title={how_section.title}>
        <div className="space-y-4 text-content">
          {how_section.steps.map((step) => (
            <div key={step.number} className="flex items-start gap-3">
              <span className="font-bold text-contrast">{step.number}</span>
              <span>
                {step.text}
                {step.link && (
                  <>
                    <a
                      href={step.link.href}
                      className="underline hover:text-contrast"
                    >
                      {" "}
                      {step.link.label}
                    </a>
                    {step.text_after && ` ${step.text_after}`}
                  </>
                )}
              </span>
            </div>
          ))}
        </div>
      </LegalSection>

      <LegalSection title={address_section.title}>
        <LegalAddress lines={address_section.lines} bold />
      </LegalSection>

      <LegalSection title={refunds_section.title}>
        <LegalParagraph>{refunds_section.text}</LegalParagraph>
      </LegalSection>

      <LegalSection title={exchanges_section.title} className="mb-0">
        <LegalParagraph>{exchanges_section.text}</LegalParagraph>
      </LegalSection>
    </LegalLayout>
  )
}
